import React from "react";
import {Alert} from 'react-bootstrap';
import {connect} from 'react-redux';
import {showAlert, hideAlert} from './state/setAlert'

class AlertOnClick extends React.Component {
    constructor(props) {
        super(props);
        this.handleDismiss = () => {
            this.props.hideAlert();
        }
    }
    render() {
        if (this.props.set_Alert) {
            return (
                <div id="alertOnClick">
                    <Alert bsStyle="warning" onDismiss={this.handleDismiss}>
                        <p style={{'margin': '0', 'color': '#ffffff', 'fontFamily': 'Roboto, sans-serif'}}>
                            Aby zacząć pracę z matą rozwiń kategorie z lewej strony i wybierz kolorowy kwadrat lub krażęk.
                        </p>
                    </Alert>
                </div>
            )
        }
        else return ''
    }
}

export default connect(
    state => ({
        bgValue: state.manageBgValue.value,
        set_Alert: state.setAlert
    }),
    {showAlert, hideAlert}
)(AlertOnClick)


// WEBPACK FOOTER //
// ./src/AlertOnClick.js